import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { configurationContext } from '../../contexts/configuration';
import { useIntl } from 'react-intl';

type ITimeProps = React.JSX.IntrinsicElements['time'] & {
	timestamp?: string | number;
};

export const Time = ({ timestamp, className, ...rest }: ITimeProps) => {
	const date = useTime(timestamp);
	return (
		<time className={classNames('message__time', className)} {...rest}>
			{date}
		</time>
	);
};

const useTime = (timestamp?: string | number) => {
	const intl = useIntl();
	const { localization } = useContext(configurationContext);
	const { time: timeFormat } = localization?.datetimes?.message_sent ?? {};

	return useMemo(() => {
		if (!timestamp) return null;
		const _date = new Date(timestamp);
		return intl.formatDate(_date, {
			dateStyle: undefined,
			timeStyle: timeFormat ?? 'short',
		});
	}, [intl, timestamp, timeFormat]);
};
